import { render, staticRenderFns } from "./Majungmul.vue?vue&type=template&id=13d154e6&"
import script from "./Majungmul.vue?vue&type=script&lang=js&"
export * from "./Majungmul.vue?vue&type=script&lang=js&"
import style0 from "./Majungmul.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports